<div class="work-card">
  <h2 class="flex flex-row space-between">
    <span>{{ groupedByDate().date | formatDate:'dd, DD.MM.YYYY' }}</span>
    @if (canCreate()) {
      <div class="flex flex-row gap-8">
        <work-ui-button
          workUiShowConfirmActionModal
          [modalOptions]="tagAktionenModalOptions"
          (actionConfirmResult)="onTagAktionConfirmed($event)"
          [iconOnly]="true"
          iconName="restart_alt"
          variant="secondary" />
        <work-ui-button
          (buttonClick)="onCreateClick()"
          [iconOnly]="true"
          iconName="add" />
      </div>
    }
  </h2>
  <p>{{ 'STUNDEN' | translate }}</p>
  <work-ui-chart-progress
    [reached]="groupedByDate().actualHours | roundToNearestFiveCents"
    [total]="groupedByDate().plannedHours" />

  @for (timerecorddetail of groupedByDate().timerecorddetails | sortBy:'timeStart'; track timerecorddetail.id) {
    <div class="padding-4 flex flex-row vertical-center space-between">
      <p [class.work-text-color-light]="!isEditable().get(timerecorddetail.id)">
        @if (timerecorddetail.timeStart && timerecorddetail.timeEnd) {
          <span>{{ (timerecorddetail.timeStart | formatTime) + '-' + (timerecorddetail.timeEnd | formatTime) }}: </span>
        }
        {{ timerecorddetail.timerecordtype?.name }} / {{ timerecorddetail.notes }}
        @if (timerecorddetail.project) {
          <span> ({{ timerecorddetail.project.numberQualified }})</span>
          @if (timerecorddetail.project.objectStreet) {
            <br><span>
              {{ timerecorddetail.project.objectStreet }}, {{ timerecorddetail.project.objectCity }}
            </span>
          }
        }
      </p>

      <div class="flex flex-row vertical-center gap-8">
        @if (timerecorddetail.locked) {
          <div class="work-text-color-warning flex flex-row vertical-center gap-4">
            <work-ui-icon name="lock" [fontSize]="16" />
            <small>{{ 'GESPERRT' | translate }}</small>
          </div>
        }
        @if (timerecorddetail.verified) {
          <div class="work-text-color-success flex flex-row vertical-center gap-4">
            <work-ui-icon name="check" [fontSize]="16" />
            <small>{{ 'VERIFIZIERT' | translate }}</small>
          </div>
        }
        @if (isEditable().get(timerecorddetail.id)) {
          <work-ui-button
            (buttonClick)="onEditClick(timerecorddetail)"
            [iconOnly]="true"
            iconName="edit"
            size="small"
            variant="secondary" />
          <work-ui-button
            workUiShowConfirmActionModal
            (actionConfirmResult)="onDeleteClick(timerecorddetail)"
            [iconOnly]="true"
            iconName="delete"
            size="small"
            variant="secondary" />
        }
      </div>
    </div>
  }
</div>
